import { React, useContext } from "react";

import {
  Dialog,
  Grid,
  DialogContent,
  DialogTitle,
  DialogActions,
  Icon,
  Typography,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import Chip from "../../../../components/basics/Chip";
import DescriptionCard from "../../../../components/cards/DescriptionCard";

import { HeaderModal, Margin } from "../styles/Emissao";
import { EmissaoContext } from "../contexts/EmissaoContext";
import useEmissaoController from "../controllers/EmissaoController";

const ModalEmissaoEndEntrega = ({
  setModalEndEntregaOpen,
  modalEndEntregaOpen,
}) => {
  const { senderDeliveryList } = useContext(EmissaoContext);
  const { handleSelectDeliveryAddress } = useEmissaoController();

  const handleClose = () => {
    setModalEndEntregaOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={modalEndEntregaOpen}
      onClose={handleClose}
      aria-labelledby="dialog-entrega"
    >
      <HeaderModal>
        <DialogTitle id="dialog-entrega">
          <Chip
            label="ENDEREÇO DE ENTREGA"
            bgcolor="primary"
            textcolor="white"
          />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          {senderDeliveryList.map((value, index) => (
            <Grid item lg={12}>
              <Margin top="10">
                <DescriptionCard
                  title={value.endereco}
                  icon={<Icon>home</Icon>}
                  onClick={() =>
                    handleSelectDeliveryAddress(setModalEndEntregaOpen, index)
                  }
                >
                  <Typography>{value.bairro}</Typography>
                  <Typography>
                    {value.cidade},{value.idestado}
                  </Typography>
                  <Typography>{value.complemento}</Typography>
                </DescriptionCard>
              </Margin>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmissaoEndEntrega;
